import { Outlet } from "react-router-dom"
import LeftMenu from "../components/LeftMenu"

const MainLayout = () => {
  return (
    <>
      <LeftMenu />
      <Outlet />
    </>
  )
}

export default MainLayout
